import Layout from '@/components/feature/Layout';
import Hero from './components/Hero';
import TrustStrip from './components/TrustStrip';
import ServicesIndex from './components/ServicesIndex';
import CarePhilosophy from './components/CarePhilosophy';
import YourVisit from './components/YourVisit';
import TeamPreview from './components/TeamPreview';
import OwnerStories from './components/OwnerStories';
import VisitUs from './components/VisitUs';
import FAQ from './components/FAQ';
import FinalCTA from './components/FinalCTA';

export default function Home() {
  return (
    <Layout>
      <Hero />
      <TrustStrip />
      <ServicesIndex />
      <CarePhilosophy />
      <YourVisit />
      <TeamPreview />
      <OwnerStories />
      <VisitUs />
      <FAQ />
      <FinalCTA />
    </Layout>
  );
}